/**
 * @prettier
 * @flow
 */
export function parseBoolean(value: string): boolean | void | null {
    if (value === undefined || value === null) {
        return (value: any);
    }
    return value === ('true': any);
}
